import { Record } from 'immutable';
import getCssVariablesTheme from 'foundations-theming/css-vars-theme';
class BrandingRecord extends Record({
  showSalesAd: true,
  primaryColor: getCssVariablesTheme.color['text-tertiary-default'],
  secondaryColor: getCssVariablesTheme.color['text-tertiary-default'],
  logoUrl: null,
  logoAltText: null,
  companyName: null
}, 'BrandingRecord') {}
export default BrandingRecord;